import { CO2Savings } from '@brenger/utils';
import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import {
  CirclePerson2,
  Col,
  DotList,
  Heading,
  IconCheckmarkCircle,
  Row,
  SectionWrapper,
  ShareButtons,
} from '../../../../brenger-shared-ui';

import { ThankYouPageType } from '../../../../hooks';
import { SessionStorageKeys } from '../../../../types';
import { translate } from '../../../../utils/localization';
import { actions as gfActions } from '../../../GeneralFlow/ducks';
import { BfButtons } from './ButtonsBf';
import { ButtonsGf } from './ButtonsGf';

interface Props {
  type?: ThankYouPageType;
  trId?: string;
  transKey?: string;
  to?: string;
  from?: string;
  distance?: number;
  savings?: CO2Savings;
}

export const Success: React.FC<Props> = ({ type, trId, transKey, to, from, distance, savings }) => {
  const dispatch = useDispatch();
  /**
   * On success we clear transaction events flag and reset the flows
   */
  React.useEffect(() => {
    sessionStorage.removeItem(SessionStorageKeys.IS_TRANSACTION_EVENT_FIRED);
    dispatch(gfActions.resetFlow(true));
  }, []);

  return (
    <Col xs={12}>
      <SectionWrapper sectionStyle={'primary'} centerContent={true}>
        <Row>
          <Col xs={12} extraClasses={'flex justify-center items-end thank-you-opening'}>
            <CirclePerson2 />
            <IconCheckmarkCircle />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={8} extraClasses={'offset-md-2'}>
            <Row>
              <Col xs={12} extraClasses={'pt-[1em] pb-[1em]'}>
                <Heading size={4}>
                  <Translate id={`request_flow.${transKey}.title`} />
                </Heading>
              </Col>
              <Col xs={12}>
                <DotList
                  items={[
                    translate(`request_flow.thank_you_page.steps_1`, { tr_id: trId?.slice(-6) }),
                    translate(`request_flow.thank_you_page.steps_2`),
                    translate(`request_flow.thank_you_page.steps_3`),
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </SectionWrapper>
      <SectionWrapper sectionStyle={'white'} centerContent={true}>
        <Row>
          {/* We don't show the fun facts yet for these flows */}
          {!['upsell', 'business'].includes(type as ThankYouPageType) && (
            <>
              <Col xs={12} md={8} extraClasses={'offset-md-2 pb-[1em] pt-[1em]'}>
                <div>
                  <h6>
                    <Translate id={`request_flow.general.thank_you.did_you_know_title`} />
                  </h6>
                  <div
                    className={'[&_b]:text-secondary'}
                    dangerouslySetInnerHTML={{
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      __html: String(
                        translate(`request_flow.general.thank_you.did_you_know_text`, {
                          co2: savings?.inKg,
                          hamburgers: `${savings?.inHamburgers} 🍔`, // Yes emoji time!!
                          shower_turns: `${savings?.inShowerTurns} 🚿`, // Yes emoji time!!
                          to,
                          from,
                          distance: `${distance?.toFixed(1)} km`,
                        })
                      ),
                    }}
                  />
                </div>
              </Col>
              <Col xs={12} md={8} extraClasses={'offset-md-2 pb-[1em]'}>
                <ShareButtons
                  message={translate(' request_flow.general.thank_you.shared_text ', {
                    co2: savings?.inKg,
                    hamburgers: savings?.inHamburgers,
                    shower_turns: savings?.inShowerTurns,
                    to,
                    from,
                    distance: `${distance?.toFixed(1)} km`,
                  })}
                />
              </Col>
            </>
          )}
          <Col xs={12} md={8} extraClasses={'offset-md-2 pb-[1em]'}>
            {type === 'business' && <BfButtons />}
            {type === 'general' && <ButtonsGf id={trId as string} />}
          </Col>
        </Row>
      </SectionWrapper>
    </Col>
  );
};
